<template>
  <v-card class="px-6 pt-2 pb-6" v-if="autobonus">
    <v-form v-model="valid">
      <v-overlay :absolute="true" :value="loading" z-index="1000" :opacity="0.3">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <select-project
        v-model="autobonus.entity_id"
        :rules="[v => !!v || 'Project is required']"
        required
        class="mb-4"
      >
      </select-project>

      <v-text-field
        v-model="autobonus.name"
        label="Name"
        :rules="[v => !!v || 'Name is required']"
        required
      />

      <v-text-field
        v-model="autobonus.comment"
        label="Comment"
      />

      <v-text-field
        v-model="autobonus.rules.promocode"
        label="Promocode"
      />

      <v-combobox
        v-model="autobonus.rules.affiliate"
        :items="affiliates"
        :loading="affiliates.length == 0"
        label="Affiliate"
        style="z-index: 999"
      ></v-combobox>

      <v-label>
        Exclude Paymethods

        <v-btn x-small outlined @click="toggleExcludePaymethods()" style="float: right">Exclude all</v-btn>
      </v-label>
      <v-container
        class="overflow-y-auto"
        style="height: 150px"
      >
        <v-chip-group
          v-model="exclude_paysystems"
          column
          multiple
        >
          <v-chip v-for="(p, i) in paymethods" :value="p.name" :key="p.name" outlined>{{ p.name }}</v-chip>
        </v-chip-group>
      </v-container>


      <v-select
        v-model="autobonus.trigger"
        :items="triggers"
        label="Trigger"
        item-value="type"
        item-text="name"
        style="z-index: 999"
        :rules="[v => !!v || 'Trigger is required']"
      ></v-select>

      <v-row class="ma-0">
        <v-select
          v-if="autobonus.trigger === 'deposit'"
          v-model="autobonus.rules.type"
          :items="triggersTypes"
          label="Type"
          item-value="type"
          item-text="name"
          style="z-index: 999"
          :rules="[v => !!v || 'Type is required']"
        />

        <v-spacer v-if="autobonus.rules.type == 'nth_deposit'" />
        <v-text-field
          v-if="autobonus.rules.type == 'nth_deposit'"
          v-model="autobonus.rules.nth"
          label="N-th deposit"
          type="number"
          :rules="[v => (!!v  && parseFloat(v) > 0) || 'Deposit number is required']"
        />
      </v-row>

      <v-select
        v-if="autobonus.rules.type === 'weekly'"
        v-model="autobonus.rules.weekdays"
        :items="weekdays"
        multiple
        label="Weekdays"
        item-value="type"
        item-text="name"
        style="z-index: 999"
        :rules="[v => (v || []).length > 0 || 'Weekdays is required']"
      />

      <v-select
        v-if="autobonus.rules.type === 'monthly'"
        v-model="autobonus.rules.monthdays"
        :items="Array.from({length: 31}, (_, i) => i + 1)"
        multiple
        @change="sortAfterChange"
        label="Month Days"
        style="z-index: 999"
        :rules="[v => (v || []).length > 0 || 'Month days is required']"
      />

      <v-row class="mx-0 px-0 pb-3">

        <v-spacer />
        <v-checkbox
          label="Verified Email"
          v-model="autobonus.rules.verification.email"
          hide-details
          class="mr-7 mt-0"
        />

        <v-checkbox
          label="Verified Phone"
          v-model="autobonus.rules.verification.phone"
          hide-details
          class="mr-0 mt-0"
        />
        <v-spacer />

      </v-row>

      <v-row justify="center" class="px-0 mx-0">
        <v-select
          v-model="autobonus.rules.rollover_type"
          :items="rolloverTypes"
          label="Rollover Type"
          item-value="type"
          item-text="name"
          style="z-index: 999"
          :rules="[v => !!v || 'Rollover Type is required']"
        ></v-select>


        <v-checkbox
          label="Sticky bonus"
          v-model="autobonus.rules.sticky"
          hide-details
          :true-value="1"
          :false-value="0"
          class="ml-3 mt-0 pt-5"
        />
      </v-row>

      <v-text-field
        v-model="autobonus.amount"
        label="Amount"
      />
      <v-text-field
        v-model="autobonus.rules.wager"
        label="Wager"
      />
      <v-text-field
        v-model="autobonus.rules.max_release"
        label="Max Release"
      />

      <v-autocomplete
        label="Exclusive for Game"
        item-text="name"
        item-value="game_id"
        clearable
        v-model="autobonus.rules.exclusive_game_id"
        style="z-index: 999"
        :items="filteredBonusGames"
      ></v-autocomplete>
      <v-autocomplete
        label="Exclusive for Brand"
        clearable
        v-model="autobonus.rules.exclusive_brand"
        style="z-index: 999"
        :items="providerBrandsAliases"
      ></v-autocomplete>
      <v-autocomplete
        label="Exclusive for System"
        clearable
        v-model="autobonus.rules.exclusive_system"
        style="z-index: 999"
        :items="providerSystemsAliases"
      ></v-autocomplete>

      <v-checkbox
        label="Don't use deposit amount in rollover calculation"
        v-model="autobonus.rules.ignore_deposit_wager"
        hide-details
        class="mr-4 mt-0"
      ></v-checkbox>
      <v-text-field
        v-model="autobonus.rules.min"
        label="Min Deposit"
      />
      <v-text-field
        v-model="autobonus.rules.max"
        label="Max Deposit"
      />
      <v-text-field
        v-model="autobonus.rules.weight"
        label="Weight"
      />


      <v-divider class="mb-3" />
      <v-btn small outlined @click="toggleFreespins()">Show Freespins</v-btn>
      <v-container v-if="!freespinsData">
        <v-text-field
          v-model="autobonus.rules.freespin.min"
          label="Min Deposit for Freespins"
        />

        <v-row justify="center" class="px-0 mx-0">
          <v-select
            v-model="autobonus.rules.freespin.rollover_type"
            :items="rolloverTypes"
            label="Rollover Type"
            item-value="type"
            item-text="name"
            style="z-index: 999"
            :rules="[v => !!v || 'Rollover Type is required']"
          />

          <v-checkbox
            label="Sticky bonus"
            v-model="autobonus.rules.freespin.sticky"
            hide-details
            :true-value="1"
            :false-value="0"
            class="ml-3 mt-0 pt-5"
          />
        </v-row>

        <v-combobox
          multiple
          label="Brands (filter)"
          v-model="freespins.brandsFilter"
          :items="freespins.brands"
          style="z-index: 999"
        ></v-combobox>
        <v-autocomplete
          label="Game"
          item-text="name"
          item-value="game_id"
          :rules="[v => !!v || 'Game is required']"
          v-model="autobonus.rules.freespin.game_id"
          style="z-index: 999"
          :items="filteredFreespinsGames"
        ></v-autocomplete>

        <v-row justify="center">
          <v-text-field
            required
            label="Amount"
            type="number"
            class="col-4"
            :rules="[v => !!v || 'Amount is required']"
            v-model="autobonus.rules.freespin.amount"
            hide-details
          />
          <v-text-field
            required
            label="Wager"
            type="number"
            class="col-3"
            :rules="[v => !!v || 'Wager is required']"
            v-model="autobonus.rules.freespin.wager"
            hide-details
          />
          <v-text-field
            label="Repeat"
            type="number"
            class="col-3"
            v-model="autobonus.rules.freespin.repeat"
            hide-details
          />
        </v-row>
        <v-row justify="center">
          <v-text-field
            required
            label="Max Release"
            type="number"
            class="col-4"
            v-model="autobonus.rules.freespin.max_release"
            hide-details
          />
          <v-text-field
            required
            label="Max FS Win"
            type="number"
            class="col-4"
            v-model="autobonus.rules.freespin.max_freespin_win"
            hide-details
          />
        </v-row>

        <v-row justify="center" class="px-0 mx-0">
          <v-autocomplete
            label="Exclusive for Brand"
            clearable
            hide-details
            v-model="autobonus.rules.freespin.exclusive_brand"
            :items="providerBrandsAliases"
            style="z-index: 999"
          />
          <v-autocomplete
            label="Exclusive for System"
            clearable
            hide-details
            v-model="autobonus.rules.freespin.exclusive_system"
            :items="providerSystemsAliases"
            style="z-index: 999"
          />

          <v-autocomplete
            label="Exclusive for Game"
            item-text="name"
            item-value="game_id"
            hide-details
            clearable
            v-model="autobonus.rules.freespin.exclusive_game_id"
            :items="filteredBonusGames"
            style="z-index: 999"
          />

          <!--          <v-checkbox-->
          <!--            label="Exclusive Game"-->
          <!--            v-model="autobonus.rules.freespin.game_exclusive"-->
          <!--            hide-details-->
          <!--            true-value="1"-->
          <!--            false-value="0"-->
          <!--            class="mr-4 mt-0"-->
          <!--          ></v-checkbox>-->
          <!--          <v-checkbox-->
          <!--            label="Exclusive Brand"-->
          <!--            v-model="autobonus.rules.freespin.provider_exclusive"-->
          <!--            hide-details-->
          <!--            true-value="1"-->
          <!--            false-value="0"-->
          <!--            class="ml-4 mt-0"-->
          <!--          ></v-checkbox>-->
        </v-row>
      </v-container>
      <v-divider class="mt-3 mb-3" />
      <v-btn small outlined @click="toggleSport()">Show Sport</v-btn>
      <v-container v-if="!sportData">
        <v-row class="mx-0 px-0">
          <v-text-field
            v-model="autobonus.rules.sport.min"
            label="Min Deposit for Sport bonus"
          />

          <v-switch
            style="width: 105px;"
            class="switch-deleted mt-4 ml-4"
            v-model="autobonus.rules.sport.internal"
            :label="autobonus.rules.sport.internal ? 'Internal' : 'External'"
          ></v-switch>
        </v-row>

        <v-row v-if="!autobonus.rules.sport.internal" justify="center" class="px-0 mx-0">
          <v-select
            label="Sport Bonus Template"
            :rules="[v => !!v || 'Sport Bonus Template is required']"
            v-model="autobonus.rules.sport.sport_bonus_id"
            :items="sportBonusTemplates"
          />

          <v-text-field
            required
            label="Amount"
            class="col-3"
            :rules="[v => !!v || 'Amount is required']"
            v-model="autobonus.rules.sport.amount"
            hide-details
          />
        </v-row>

        <template v-if="autobonus.rules.sport.internal">
          <v-row justify="center" class="px-0 mx-0">
            <v-select
              label="Rollover Type"
              :rules="[v => !!v || 'Rollover Type is required']"
              v-model="autobonus.rules.sport.rollover_type"
              item-value="type"
              item-text="name"
              :items="rolloverTypes"
            />

            <v-checkbox
              label="Sticky bonus"
              v-model="autobonus.rules.sport.sticky"
              hide-details
              :true-value="1"
              :false-value="0"
              class="ml-3 mt-0 pt-5"
            />
          </v-row>

          <v-select
            label="Type"
            :rules="[v => !!v || 'Type is required']"
            v-model="autobonus.rules.sport.bonus_type"
            :items="sportBonusTypes"
          />
          <v-row justify="center">
            <v-text-field
              required
              label="Amount"
              class="col-3"
              :rules="[v => !!v || 'Amount is required']"
              v-model="autobonus.rules.sport.amount"
              hide-details
            />
            <v-text-field
              required
              label="Wager"
              type="number"
              class="col-2"
              :rules="[v => !!v || 'Wager is required']"
              v-model="autobonus.rules.sport.wager"
              hide-details
            />
            <v-text-field
              required
              label="Max Release"
              type="number"
              class="col-3"
              v-model="autobonus.rules.sport.max_release"
              hide-details
            />
          </v-row>
        </template>

      </v-container>

      <v-divider class="mt-3 mb-3" />
      <v-btn small outlined @click="toggleOverdraft()">Overdraft</v-btn>
      <v-container v-if="!overdraftData">
        <v-text-field
          v-model="autobonus.rules.overdraft.min"
          label="Min Deposit for Overdraft"
        />

        <v-row justify="center">
          <v-text-field
            required
            label="Amount"
            class="col-5"
            :rules="[v => !!v || 'Amount is required']"
            v-model="autobonus.rules.overdraft.amount"
            hide-details
          />
        </v-row>

        <v-row justify="center" class="px-0 mx-0">
          <v-autocomplete
            label="Exclusive for Brand"
            clearable
            hide-details
            v-model="autobonus.rules.overdraft.exclusive_brand"
            :items="providerBrandsAliases"
            style="z-index: 999"
          />
          <v-autocomplete
            label="Exclusive for System"
            clearable
            hide-details
            v-model="autobonus.rules.overdraft.exclusive_system"
            :items="providerSystemsAliases"
            style="z-index: 999"
          />

          <v-autocomplete
            label="Exclusive for Game"
            item-text="name"
            item-value="game_id"
            hide-details
            clearable
            v-model="autobonus.rules.overdraft.exclusive_game_id"
            :items="filteredBonusGames"
            style="z-index: 999"
          />

        </v-row>
      </v-container>
      <v-divider :class="{'mt-3': sportData, 'mb-3': true}" />

      <v-select
        v-model="autobonus.rules.country"
        :items="countries"
        :rules="[v => !!v || 'Country is required']"
        label="Country"
        required
        multiple
        clearable
        item-value="code"
        item-text="title"
      />
      <v-select
        v-model="autobonus.rules.exclude_country"
        :items="$store.state.app.countries"
        label="Exclude Countries"
        required
        multiple
        clearable
        item-value="code"
        item-text="title"
      />
      <v-select
        v-model="autobonus.currency"
        :items="$store.state.auth.currencies"
        :rules="[v => !!v || 'Currency is required']"
        label="Currency"
        required
      />


      <v-text-field
        v-model="autobonus.date_start"
        label="Start"
        :rules="[v => !!v || 'Date Start is required']"
        placeholder="Format: YYYY-MM-DD HH:mm:ss (eg: 2020-01-01 00:00:00)"
        v-mask="`####-##-## ##:##:##`"
        required
      />
      <v-text-field
        v-model="autobonus.date_end"
        label="End"
        :rules="[v => !!v || 'Date End is required']"
        placeholder="Format: YYYY-MM-DD HH:mm:ss (eg: 2020-10-29 23:59:59)"
        v-mask="`####-##-## ##:##:##`"
        required
      />

    </v-form>
  </v-card>

</template>

<style scoped>
  .trumbowyg-box, .trumbowyg-editor {
    min-height: 550px !important;
  }

  .v-card {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
</style>

<script>
  import { includes, uniq, isNaN, toNumber, isEmpty, isArray, map, get, filter, concat, omit } from 'lodash'
  import { API } from '@/utils/api'

  import { mask } from 'vue-the-mask'
  import Vue from 'vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    directives: {
      mask,
    },

    props: [ 'autobonus', 'loading' ],

    components: {
      SelectProject,
    },

    data: () => ({
      valid: false,
      config: {},
      triggers: [
        { type: 'register', name: 'Register' },
        { type: 'deposit', name: 'Deposit' },
        { type: 'verification', name: 'Verification' },
        { type: 'kyc_verification', name: 'KYC Verification' },
      ],
      weekdays: [
        { type: '1', name: 'Sunday' },
        { type: '2', name: 'Monday' },
        { type: '3', name: 'Tuesday' },
        { type: '4', name: 'Wednesday' },
        { type: '5', name: 'Thursday' },
        { type: '6', name: 'Friday' },
        { type: '7', name: 'Saturday' },
      ],
      rolloverTypes: [
        { type: 'bonus', name: 'Bonus' },
        { type: 'cash', name: 'Cash' }
      ],
      triggersTypes: [
        { type: 'first_deposit', name: 'First Deposit' },
        { type: 'second_deposit', name: 'Second Deposit' },
        { type: 'third_deposit', name: 'Third Deposit' },
        { type: 'forth_deposit', name: 'Forth Deposit' },
        { type: 'nth_deposit', name: 'N-th Deposit' },
        { type: 'weekly', name: 'Weekly' },
        { type: 'monthly', name: 'Monthly' },
        { type: 'weekend', name: 'Weekend' },
        { type: 'once', name: 'Once by period' }
      ],
      sportBonusTypes: [
        { text: 'Bonus money', value: 'STD' },
        { text: 'Free bet', value: 'FB' },
        { text: 'No Risk Bet', value: 'NRB' },
        { text: 'Free money bet', value: 'FMB' }
      ],
      affiliates: [],
      paymethods: [],
      sportBonusTemplates: [],
      exclude_paysystems: [],
      sportData: false,
      overdraftData: false,
      freespinsData: false,
      freespins: {
        brands: [],
        brandsFilter: [],
        games: [],
      },
      bonus: {
        brands: [],
        brandsFilter: [],
        games: [],
      },
    }),

    watch: {
      'autobonus.rules.type': function () {
        if (this.autobonus.rules.type !== 'nth_deposit') {
          delete this.autobonus.rules.nth
        }
      },
      valid (v) {
        this.$emit('update-validation', v)
      },
      autobonus (v) {
        if (this.autobonus) {
          if (!this.autobonus.rules.country) this.autobonus.rules.country = [ 'any' ]
          if (!this.autobonus.rules.wager) this.autobonus.rules.wager = 40
          if (!this.autobonus.trigger) this.autobonus.trigger = 'deposit'
          if (!this.autobonus.rules.rollover_type) this.autobonus.rules.rollover_type = 'cash'
          if (!this.autobonus.rules.verification) this.autobonus.rules.verification = {}

          this.exclude_paysystems = this.autobonus.rules.exclude_paysystems

          if (this.autobonus.rules.freespin) {
            this.autobonus.rules.freespin.game_id = toNumber(this.autobonus.rules.freespin.game_id)
          }

          if (get(this.autobonus, 'rules.freespin', false)) {
            this.freespinsData = false
          } else {
            this.freespinsData = true
          }

          if (get(this.autobonus, 'rules.sport', false)) {
            this.sportData = false
          } else {
            this.sportData = true
          }

          if (get(this.autobonus, 'rules.overdraft', false)) {
            this.overdraftData = false
          } else {
            this.overdraftData = true
          }
        }
      },
      exclude_paysystems (v) {
        if (!this.autobonus) return
        if (this.exclude_paysystems && this.exclude_paysystems.length > 0) {
          this.autobonus.rules.exclude_paysystems = this.exclude_paysystems
        } else {
          delete this.autobonus.rules.exclude_paysystems
        }
      },
      'autobonus.entity_id': function () {
        if (!this.autobonus) return
        if (this.autobonus.entity_id) {
          this.loadAffiliates()
          this.loadPaymethods()
          this.loadFreespinsGames()
          this.loadSportBonusTemplates()
        }
      },
      'autobonus.trigger': function () {
        if (!this.autobonus) return
        if (this.autobonus.trigger !== 'deposit' && this.autobonus.rules) {
          delete this.autobonus.rules.type
        }
      },
      'autobonus.rules.country': function (n) {

        if (!this.autobonus) return

        if (this.autobonus.rules.country.length == 0 || (this.autobonus.rules.country.length > 1 && n[n.length - 1] == 'any')) {
          this.autobonus.rules.country = [ 'any' ]
        }

        if (includes(this.autobonus.rules.country, 'any') && this.autobonus.rules.country.length > 1) {
          this.autobonus.rules.country = filter(this.autobonus.rules.country, (o) => o != 'any')
        }

      }
    },

    methods: {
      isNumber: (v) => !isNaN(toNumber(v)) || isEmpty(v),

      sortAfterChange: function (n) {
        if (isArray(n)) {
          n.sort((a, b) => a - b)
        }
      },

      loadSportBonusTemplates () {
        return API.call('/$v/bonus_template/sport_bonus_list.json', { deleted: [ 0 ] }, null, this.autobonus.entity_id).then(resp => {
          this.sportBonusTemplates = map(resp.data, o => ({ text: o.name, value: o.sport_bonus_id }))
        }).catch(() => {
        })
      },

      loadAffiliates () {
        return API.call('/$v/affiliate/list.json', {}, null, this.autobonus.entity_id).then(resp => {
          this.affiliates = resp.data
        })
      },

      loadPaymethods () {
        return API.call('/$v/paymethod/name_list.json', {}, null, this.autobonus.entity_id).then(resp => {
          this.paymethods = resp.data
        })
      },

      loadFreespinsGames () {
        return API.call('/$v/game/list.json', {}, null, this.autobonus.entity_id).then(resp => {
          this.bonus.games = resp.data
          this.bonus.brands = uniq(map(resp.data, 'brand.alias'))
          this.freespins.games = filter(resp.data, (g) => g.allow_freespins > 0)
          this.freespins.brands = map(this.freespins.games, 'brand.alias')
        }).catch(e => {
        })
      },

      toggleExcludePaymethods () {
        if (this.autobonus.rules) {
          this.exclude_paysystems = this.exclude_paysystems.length !== this.paymethods.length || this.exclude_paysystems.length === 0 ? map(this.paymethods, 'name') : []
        }
      },

      toggleFreespins () {
        if (!this.freespinsData) {
          this.freespinsData = this.autobonus.rules.freespin
          delete this.autobonus.rules.freespin
        } else {
          if (this.freespinsData !== true) {
            this.autobonus.rules.freespin = this.freespinsData
          } else {
            this.autobonus.rules.freespin = {}
          }
          this.freespinsData = false
        }
      },

      toggleSport () {
        if (!this.sportData) {
          this.sportData = this.autobonus.rules.sport
          delete this.autobonus.rules.sport
        } else {
          if (this.sportData !== true) {
            this.autobonus.rules.sport = this.sportData
          } else {
            this.autobonus.rules.sport = Vue.observable({ internal: true })
          }
          this.sportData = false

        }
      },
      toggleOverdraft () {
        if (!this.overdraftData) {
          this.overdraftData = this.autobonus.rules.overdraft
          delete this.autobonus.rules.overdraftData
        } else {
          if (this.overdraftData !== true) {
            this.autobonus.rules.overdraft = this.overdraftData
          } else {
            this.autobonus.rules.overdraft = {}
          }
          this.overdraftData = false

        }
      },
    },

    computed: {
      filteredBonusGames: function () {
        return this.bonus.games.filter(g => {
          return this.bonus.brandsFilter.length < 1 || (this.bonus.brandsFilter.includes(g.brand.alias))
        })
      },
      providerBrandsAliases: function () {
        return map(this.bonus.games, (i) => [ get(i, 'system_alias'), get(i, 'brand_alias') ].join('.'))
      },
      providerSystemsAliases: function () {
        return map(this.bonus.games, 'system_alias')
      },
      filteredFreespinsGames: function () {
        return this.freespins.games.filter(g => {
          return this.freespins.brandsFilter.length < 1 || (this.freespins.brandsFilter.includes(g.brand.alias))
        })
      },
      countries () {
        return concat([ { 'code': 'any', 'title': 'Any' } ], this.$store.state.app.countries)
      }
    },
  }

  /*
systemId: 1
event_id: 1
name: Welcome
rules[hide]: 0
comment: Welcome 1
rules[affiliate]:
event_type: bonus
trigger: deposit
rules[type]: first_deposit
rules[rollover_type]: cash
amount: 100.00%
wager: 30
rules[min]: 1000
rules[max]: 10000
rules[weight]: 40
rules[freespin_min]: 0
rules[freespin][rollover_type]: cash
rules[freespin][game_id]:
rules[freespin][lines]:
rules[freespin][bet]:
rules[freespin][wager]: 40
rules[freespin][count]:
rules[freespin][repeat]: 1
rules[freespin][game_exclusive]: 0
rules[freespin][provider_exclusive]: 0
rules[country]: any
currency: RUB
date_start: 2019-09-01 16:10:00
date_end: 2020-09-04 16:10:00
rules[exclude_paysystems][]: piastrix_rub
rules[exclude_paysystems][]: piastrix_eur
   */
</script>
